import { useCallback } from 'react';
import { useTheme } from '@mui/material';
import { GridContainer, GridItem } from '@formComponents';
import { normalizeIso8601Date } from '@libs/dateTime';

import {
    TimesheetsInputSearch,
    TimeSheetsNavigator,
    TimesheetsYearPicker
} from 'timeAndAttendance/components';

import useYearlyTimesheets, {
    SET_EMAIL,
    SET_YEAR,
    TIMESHEET_NEXT_YEAR,
    TIMESHEET_PREV_YEAR
} from './useYearlyTimesheets';

const Filters = () => {
    const { spacing } = useTheme();
    const [{ year, isNextDisabled }, dispatch] = useYearlyTimesheets();

    /** Handle email search */
    const handleSearch = useCallback(
        (value) => {
            dispatch({
                type: SET_EMAIL,
                payload: value
            });
        },
        [dispatch]
    );

    /** Handle year change */
    const handleYearChange = useCallback(
        (value) => {
            try {
                if (value) {
                    const normalized = normalizeIso8601Date(value);
                    if (!normalized.includes('Invalid Date')) {
                        const year = new Date(normalized).getFullYear(); // <-- extract year
                        dispatch({
                            type: SET_YEAR,
                            payload: year
                        });
                    }
                }
            } catch (err) {
                console.error('Error setting year:', err);
            }
        },
        [dispatch]
    );

    /** Year navigation */
    const handlePrevClick = useCallback(() => {
        dispatch({ type: TIMESHEET_PREV_YEAR });
    }, [dispatch]);

    const handleNextClick = useCallback(() => {
        dispatch({ type: TIMESHEET_NEXT_YEAR });
    }, [dispatch]);

    return (
        <GridContainer sx={{ paddingBottom: spacing(2) }}>
            {/* Year Navigator */}
            <GridItem md={4}>
                <TimeSheetsNavigator
                    onPrevClick={handlePrevClick}
                    onNextClick={handleNextClick}
                    isNextDisabled={isNextDisabled}
                >
                    <TimesheetsYearPicker
                        input={{
                            value: new Date(`${year}-01-01`),
                            onChange: handleYearChange
                        }}
                    />
                </TimeSheetsNavigator>
            </GridItem>

            {/* Search by Email */}
            <GridItem md={3}>
                <TimesheetsInputSearch
                    name='yearly-view-employee-email'
                    handleSearch={handleSearch}
                    placeholder='Search by email...'
                />
            </GridItem>
        </GridContainer>
    );
};

export default Filters;
